import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { innerBg } from '../ui/media';

const MainLayout = () => {
  
  return (
    <div className="flex min-h-screen bg-gray-50">
      <div style={{background: `url(${innerBg})`, backgroundSize: "100% 100%"}} className={`flex flex-col flex-1 transition-all duration-300`}>
        <Header />
        <main className="flex-1 pt-6 overflow-auto mt-12">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default MainLayout;